const loginRoute = {
    name: 'Login',
    path: '/login',
    component: () => import('@/app/modules/login/Login.vue'),
    meta: {
        needsAuthenticatedUser: false,
    },
};

const LoginRoutes = [
    loginRoute,
    {
        name: 'AuthCallback',
        path: '/auth/callback',
        component: () => import('@/app/modules/login/AuthCallback.vue'),
        meta: {
            needsAuthenticatedUser: false,
        },
    },
];

if (import.meta.env.VITE_DEV_LOGIN_ENDPOINT) {
    LoginRoutes.push({
        name: 'LoginDev',
        path: '/login-dev',
        component: () => import('@/app/modules/login/DevLogin.vue'),
        meta: {
            needsAuthenticatedUser: false,
        },
    });
}

export default LoginRoutes;
